import {
    createParamsResetHandler
} from "app/pages/digital-marketing/monitor-and-protect/shared/redirect-handlers/trademarks/params-reset-factory";

import { TRADEMARK_ROUTES } from "../../../app/trademark/constants";
import type { IRedirectCase } from "../types";

import { durationResetHandler } from "./duration-reset";

export type { RedirectHandler, IRedirectCase } from "../types";

const TRADEMARK_STATE_NAMES: string[] = Object.values(TRADEMARK_ROUTES).map((route) => route.stateName);

export const trademarksRedirectCases: IRedirectCase[] = [
    {
        name: "paramsReset",
        handler: createParamsResetHandler(TRADEMARK_STATE_NAMES),
    },
    {
        name: "durationReset",
        handler: durationResetHandler,
    },
] as const;
